import ApplicationController from '../application_controller'
import { Controller } from 'stimulus'

export default class extends ApplicationController {
  static targets = ['notesCount', 'actionsCount', 'billsCount',
    'organizationalNotesCount', 'groupNotesCount']

  connect() {
    this.retrieveCount()
  }

  retrieveCount() {
    Rails.ajax({
      type: 'get',
      url: `/reports/stakeholder_counts/${this.data.get('id')}`,
      data: `stakeholder_type=${this.data.get('type')}`,
      success: (data) => this.updateCounts(data)
    })
  }

  updateCounts(data) {
    if (this.hasNotesCountTarget) {
      const notesCount = parseInt(data.group_notes) + parseInt(data.organizational_notes)
      this.notesCountTarget.innerHTML = `(${notesCount} total)`
      this.groupNotesCountTarget.innerHTML = `(${data.group_notes} total)`
      this.organizationalNotesCountTarget.innerHTML = `(${data.organizational_notes} total)`
    }
    if (this.hasActionsCountTarget) {
      this.actionsCountTarget.innerHTML = `(${data.actions} total)`
    }
    if (this.hasBillsCountTarget) {
      this.billsCountTarget.innerHTML = `(${data.bills} total)`
    }
  }
}
